import ProductConcernSubstancesStep from './ProductConcernSubstancesStep.vue'
import { productConcernSubstancesDescriptor } from './descriptor'
import { createProductConcernSubstancesController } from './product-concern-substances-controller'

const productConcernSubstancesStepImplementation = Object.freeze({
    descriptor: productConcernSubstancesDescriptor,
    component: ProductConcernSubstancesStep,
    createController: createProductConcernSubstancesController,
})

export {
    ProductConcernSubstancesStep,
    createProductConcernSubstancesController,
    productConcernSubstancesDescriptor,
    productConcernSubstancesStepImplementation,
}
